import { ILanguageExtended } from "@multiweb/types/contracts";
import { InvalidArgumentException } from "../../../../Global/Base/Exceptions";
import { ActionType, IAction } from "../../../UI.Controls/Actions/IAction";
import { MenuType } from "../../../UI.Controls/Actions/MenuType";
import { IContentBuilder } from "../DataBuilders/IContentBuilder";
import { IFrame } from "../XGControls/IFrame";
import { FormUICustomProperty, IFormUI } from "./FormUI";
import { MenuUIStandard } from "./MenuUIStandard";

export class MenuUIStandardChart extends MenuUIStandard {
    private _textDateBuilder: IContentBuilder;
    private _textChartNameElement: HTMLElement | undefined;
    public override isVisible;

    constructor(formUI: IFormUI, frameElement: HTMLElement, isVisible = false, ctrlID: string, frame: IFrame | undefined, getLanguages: () => Promise<readonly ILanguageExtended[]>) {
        super(formUI, frameElement, isVisible, ctrlID, frame, getLanguages);
        this.element.classList.add("chart-frame-toolbar");
        this.isVisible = isVisible;
    }

    public override addAction<T extends IAction>(action: T): T {
        if (!action) {
            throw new InvalidArgumentException("Invalid action argument");
        }

        switch (action.actionType) {
            case ActionType.standardSaveAll:
                action.toMenu = MenuType.mtStandardAction;
                break;
            case ActionType.standardChartSettings:
                action.toMenu = MenuType.mtSettings;
                break;
            case ActionType.standardMoreSettings:
            case ActionType.standardChartName:
                action.toMenu = MenuType.mtFormControl;
                break;
        }

        return super.addAction(action);
    }

    public override setProperty(propertyName: FormUICustomProperty | string, newValue: any): void {
        if (typeof propertyName === "string")
            propertyName = propertyName.toLowerCase();

        switch (propertyName) {
            case "chartname":
                this._textDateBuilder = newValue;
                this._addChartName();
                break;
            default:
        }
    }

    private async _addChartName(): Promise<void> {
        if (!this._textDateBuilder)
            return;

        this._textChartNameElement = await this._textDateBuilder.build();
        const formControl = this._actionContainer.element.querySelector("[data-tomenu='mtFormControl']");
        formControl.insertBefore(this._textChartNameElement, formControl.firstChild);
    }
}
